<template>
  <div class="promoter-stats">
    <el-card class="search-card" shadow="never">
      <el-form :inline="true" :model="searchForm" size="small" label-width="120px">
        <el-form-item label="推广人姓名：">
          <el-input v-model.trim="searchForm.promoterName" class="promoter-input" placeholder="请输入推广人姓名" clearable @keyup.enter.native="searchFirstPage"></el-input>
        </el-form-item>
        <el-form-item label="所属油站：">
          <el-select v-model="searchForm.gasId" clearable placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in gasList" :key="item.gasId" :label="item.gasName" :value="item.gasId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="自定义日期：">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="handleDateRangeChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="快速筛选：">
          <el-radio-group v-model="quickDateType" @change="handleQuickDateChange">
            <el-radio-button label="today">今日</el-radio-button>
            <el-radio-button label="seven">近7天</el-radio-button>
            <el-radio-button label="thirty">近30天</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="btn-wrap">
        <el-button type="primary" size="mini" @click="searchFirstPage">查询</el-button>
        <el-button size="mini" @click="resetSearch">重置</el-button>
        <download-button :downloadApi="exportPromoterStatsList" :queryParams="exportParams"></download-button>
      </div>
    </el-card>

    <el-card shadow="never">
      <el-table v-loading="tableLoading" :data="tableData" size="small" stripe style="width: 100%">
        <el-table-column label="排名" prop="rank" min-width="70" align="center"></el-table-column>
        <el-table-column label="推广人姓名" prop="promoterName" min-width="110" align="center"></el-table-column>
        <el-table-column label="人员角色" prop="roleName" min-width="100" align="center"></el-table-column>
        <el-table-column label="所属油站" prop="gasName" min-width="140" align="center"></el-table-column>
        <el-table-column label="推广新客数" prop="newCustomerCount" min-width="110" align="center"></el-table-column>
        <el-table-column label="推广新客单数" prop="newCustomerOrderCount" min-width="120" align="center"></el-table-column>
        <el-table-column label="推广老客单数" prop="oldCustomerOrderCount" min-width="120" align="center"></el-table-column>
        <el-table-column label="推广人新客收益 (元)" prop="promoterNewCustomerIncome" min-width="160" align="center"></el-table-column>
        <el-table-column label="推广人老客收益 (元)" prop="promoterOldCustomerIncome" min-width="160" align="center"></el-table-column>
        <el-table-column label="推广人收益总额 (元)" prop="promoterTotalIncome" min-width="160" align="center"></el-table-column>
        <el-table-column label="新客订单推广费 (元)" prop="newCustomerOrderPromotionFee" min-width="160" align="center"></el-table-column>
        <el-table-column label="老客订单推广费 (元)" prop="oldCustomerOrderPromotionFee" min-width="160" align="center"></el-table-column>
        <el-table-column label="订单推广费总额 (元)" prop="orderPromotionFeeTotal" min-width="160" align="center"></el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="pageChange"
          :current-page="pagination.pageIndex"
          :page-sizes="pageSizes"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalRow">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { getDistributorResourceList, queryPromoterStatsList, exportPromoterStatsList } from '@/api/promotionManage'


export default {
  name: 'promotionPromoterStats',
  data () {
    return {
      exportPromoterStatsList,
      quickDateType: 'today',
      searchForm: {
        promoterName: '',
        gasId: '',
        dateRange: []
      },
      exportParams: {},
      gasList: [],
      tableLoading: false,
      tableData: [],
      totalRow: 0,
      pagination: {
        pageIndex: 1,
        pageSize: 10
      },
      pageSizes: [10, 50, 100, 200]
    }
  },
  created () {
    this.setQuickDateRange('today')
    this.getGasList()
    this.handleSearch()
  },
  methods: {
    isSuccess (code) {
      return code === 0 || code === 200
    },
    async refreshAfterAuthenticated () {
      await this.getGasList()
      await this.handleSearch()
    },
    async getGasList () {
      try {
        const { code, result } = await getDistributorResourceList()
        if (!this.isSuccess(code)) return
        this.gasList = (result || [])
          .map(item => ({
            ...item,
            gasId: item.gasId || item.stationId || item.id,
            gasName: item.gasName || item.stationName || item.name
          }))
          .filter(item => item.gasId && item.gasName)
      } catch (err) {
        this.gasList = []
      }
    },
    setQuickDateRange (type) {
      const end = dayjs().format('YYYY-MM-DD')
      const startMap = {
        today: dayjs().format('YYYY-MM-DD'),
        seven: dayjs().subtract(6, 'day').format('YYYY-MM-DD'),
        thirty: dayjs().subtract(29, 'day').format('YYYY-MM-DD')
      }
      this.searchForm.dateRange = [startMap[type], end]
    },
    handleQuickDateChange (type) {
      this.setQuickDateRange(type)
      this.pagination.pageIndex = 1
      this.handleSearch()
    },
    handleDateRangeChange () {
      this.quickDateType = 'custom'
    },
    buildSearchParams () {
      const [beginDate = '', endDate = ''] = this.searchForm.dateRange || []
      return {
        promoterName: this.searchForm.promoterName,
        gasId: this.searchForm.gasId,
        beginTime: beginDate ? `${beginDate} 00:00:00` : '',
        endTime: endDate ? `${endDate} 23:59:59` : ''
      }
    },
    normalizeRow (item) {
      // 推广人统计接口字段以 promoterStatistics/queryList 文档为准，兼容早期页面字段避免空列。
      return {
        ...item,
        rank: item.rank || item.Rank,
        roleName: item.roleName || item.role,
        newCustomerCount: item.newCustomerCount || item.newCustomer,
        newCustomerOrderCount: item.newCustomerOrderCount || item.newOrder,
        oldCustomerOrderCount: item.oldCustomerOrderCount || item.repeatOrder,
        promoterNewCustomerIncome: item.promoterNewCustomerIncome || item.newProfit,
        promoterOldCustomerIncome: item.promoterOldCustomerIncome || item.repeatProfit,
        promoterTotalIncome: item.promoterTotalIncome || item.promoterIncomeTotal || item.sumProfit,
        newCustomerOrderPromotionFee: item.newCustomerOrderPromotionFee || item.gasNewCustomerIncome || item.gasNewProfit,
        oldCustomerOrderPromotionFee: item.oldCustomerOrderPromotionFee || item.gasOldCustomerIncome || item.gasRepeatProfit,
        orderPromotionFeeTotal: item.orderPromotionFeeTotal || item.gasIncomeTotal || item.sumGasProfit
      }
    },
    searchFirstPage () {
      this.pagination.pageIndex = 1
      this.handleSearch()
    },
    async handleSearch () {
      this.tableLoading = true
      try {
        const params = this.buildSearchParams()
        this.exportParams = params
        const { code, result = [], totalRow = 0 } = await queryPromoterStatsList({
          ...params,
          pageNum: this.pagination.pageIndex,
          pageSize: this.pagination.pageSize
        })
        if (!this.isSuccess(code)) {
          this.tableData = []
          this.totalRow = 0
          return
        }
        const list = Array.isArray(result) ? result : (result.list || [])
        this.tableData = list.map(this.normalizeRow)
        this.totalRow = parseInt(totalRow || result.total || 0)
      } catch (err) {
        this.tableData = []
        this.totalRow = 0
      } finally {
        this.tableLoading = false
      }
    },
    pageChange (currentPage) {
      this.pagination.pageIndex = currentPage
      this.handleSearch()
    },
    handleSizeChange (pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.pageIndex = 1
      this.handleSearch()
    },
    resetSearch () {
      this.searchForm.promoterName = ''
      this.searchForm.gasId = ''
      this.quickDateType = 'today'
      this.pagination.pageIndex = 1
      this.setQuickDateRange('today')
      this.handleSearch()
    }
  }
}
</script>

<style lang="less" scoped>
.promoter-stats {
  .search-card {
    margin-bottom: 10px;

    /deep/ .el-form {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/ .el-form-item {
      margin-right: 24px;
    }

    .promoter-input {
      width: 200px;
    }

    .el-select {
      width: 180px;
    }

    .btn-wrap {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

  .pagination-wrap {
    padding: 15px 0 5px;
    text-align: right;
  }
}
</style>
